var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 5.5C10.4249 5.5 5.5 10.4249 5.5 16.5C5.5 22.5751 10.4249 27.5 16.5 27.5C22.5751 27.5 27.5 22.5751 27.5 16.5V15.8125C27.5 15.0531 28.1156 14.4375 28.875 14.4375C29.6344 14.4375 30.25 15.0531 30.25 15.8125V16.5C30.25 24.0939 24.0939 30.25 16.5 30.25C8.90609 30.25 2.75 24.0939 2.75 16.5C2.75 8.90609 8.90609 2.75 16.5 2.75H17.1875C17.9469 2.75 18.5625 3.36561 18.5625 4.125C18.5625 4.88439 17.9469 5.5 17.1875 5.5H16.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6714 3.87871C24.3941 3.15601 25.3743 2.75 26.3964 2.75C27.4184 2.75 28.3986 3.15601 29.1213 3.87871C29.844 4.60141 30.25 5.5816 30.25 6.60365C30.25 7.6257 29.844 8.60589 29.1213 9.32859L28.0445 10.4054C27.5075 10.9424 26.6369 10.9424 26.1 10.4054L22.5946 6.90007C22.0576 6.3631 22.0576 5.4925 22.5946 4.95553L23.6714 3.87871ZM20.6501 8.84462C20.1131 8.30765 19.2425 8.30765 18.7055 8.84462L12.5712 14.9789C12.395 15.1552 12.27 15.376 12.2095 15.6177L11.0411 20.2915C10.9239 20.7601 11.0612 21.2557 11.4028 21.5973C11.7443 21.9388 12.2399 22.0761 12.7085 21.9589L17.3823 20.7905C17.6241 20.7301 17.8449 20.605 18.0211 20.4288L24.1554 14.2945C24.6924 13.7575 24.6924 12.8869 24.1554 12.35L20.6501 8.84462Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.5fe38ef5.svg";
export { ForwardRef as ReactComponent };